import * as React from "react";
import { Dialog, DialogContent, DialogTrigger } from "@/components/ui/dialog";
import { PlusCircle } from "lucide-react";
import AddExpenseForm from "./Admin/AddExpense";

const ExpenseFormDialog = ({ editExpense, open, setOpen, setEdit }) => {
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors flex items-center gap-2">
          <PlusCircle className="w-5 h-5" />
          Add Expense
        </button>
      </DialogTrigger>
      <DialogContent className="max-w-3xl">
        <AddExpenseForm setEdit={setEdit} editExpanse={editExpense} />
      </DialogContent>
    </Dialog>
  );
};

export default ExpenseFormDialog;
